import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfileInfo.css';

// Mock user data
const mockUserInfo = {
  name: 'M',
  email: 'mrlcreation6@gmail.com',
  legalName: 'Dayo Odewade',
  referralCode: 'COINSHERTO3R41C9IZI4',
  accountLimits: {
    fiatDepositWithdrawal: '50k USD Daily',
    cryptoDeposit: 'Unlimited',
    cryptoWithdrawal: '8M USDT daily',
    p2pTransactions: 'Unlimited'
  }
};

const ProfileInfo: React.FC = () => {
  const navigate = useNavigate();
  const [copySuccess, setCopySuccess] = useState(false);

  const handleCopyReferralCode = () => {
    navigator.clipboard.writeText(mockUserInfo.referralCode);
    setCopySuccess(true);
    setTimeout(() => setCopySuccess(false), 2000);
  };

  return (
    <div className="profile-info-container">
      {/* Header */}
      <div className="profile-info-header">
        <button className="profile-info-back-button" onClick={() => navigate('/profile')}>
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
            <path d="M10 12L6 8L10 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </button>
        <h1 className="profile-info-header-title">Registration Info</h1>
      </div>

      {/* Profile Header Card */}
      <div className="profile-info-header-card">
        <div className="profile-info-avatar-wrapper">
          <div className="profile-info-avatar-gradient" />
          <div className="profile-info-avatar">
            <span className="profile-info-avatar-text">{mockUserInfo.name}</span>
          </div>
        </div>
        <div className="profile-info-email">{mockUserInfo.email}</div>
      </div>

      {/* Account Limits Section */}
      <div className="profile-info-section">
        <h2 className="profile-info-section-title">Account limits</h2>
        <div className="profile-info-card">
          <div className="profile-info-row">
            <div className="profile-info-label-multiline">
              Fiat deposit & withdrawal<br />limits
            </div>
            <div className="profile-info-value">{mockUserInfo.accountLimits.fiatDepositWithdrawal}</div>
          </div>
          <div className="profile-info-divider" />
          
          <div className="profile-info-row">
            <div className="profile-info-label">Crypto deposit limits</div>
            <div className="profile-info-value profile-info-value-green">{mockUserInfo.accountLimits.cryptoDeposit}</div>
          </div>
          <div className="profile-info-divider" />
          
          <div className="profile-info-row">
            <div className="profile-info-label">Crypto withdrawal limit</div>
            <div className="profile-info-value">{mockUserInfo.accountLimits.cryptoWithdrawal}</div>
          </div>
          <div className="profile-info-divider" />
          
          <div className="profile-info-row">
            <div className="profile-info-label">P2P transactions limit</div>
            <div className="profile-info-value profile-info-value-green">{mockUserInfo.accountLimits.p2pTransactions}</div>
          </div>
        </div>
      </div>

      {/* Personal Information Section */}
      <div className="profile-info-section">
        <h2 className="profile-info-section-title">Personal information</h2>
        <div className="profile-info-card">
          <div className="profile-info-row">
            <div className="profile-info-label">Legal name</div>
            <div className="profile-info-value">{mockUserInfo.legalName}</div>
          </div>
          <div className="profile-info-divider" />
          
          <div className="profile-info-row profile-info-row-column">
            <div className="profile-info-label">Referral ID</div>
            <div className="profile-info-referral-box">
              <div className="profile-info-referral-code">{mockUserInfo.referralCode}</div>
              <button 
                className="profile-info-copy-button" 
                onClick={handleCopyReferralCode}
                aria-label="Copy referral code"
              >
                {copySuccess ? (
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.3333 4L6 11.3333L2.66667 8" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                ) : (
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                    <path d="M13.3333 6H7.33333C6.59695 6 6 6.59695 6 7.33333V13.3333C6 14.0697 6.59695 14.6667 7.33333 14.6667H13.3333C14.0697 14.6667 14.6667 14.0697 14.6667 13.3333V7.33333C14.6667 6.59695 14.0697 6 13.3333 6Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    <path d="M3.33333 10H2.66667C2.31304 10 1.97391 9.85952 1.72386 9.60947C1.47381 9.35942 1.33333 9.02029 1.33333 8.66667V2.66667C1.33333 2.31304 1.47381 1.97391 1.72386 1.72386C1.97391 1.47381 2.31304 1.33333 2.66667 1.33333H8.66667C9.02029 1.33333 9.35942 1.47381 9.60947 1.72386C9.85952 1.97391 10 2.31304 10 2.66667V3.33333" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                  </svg>
                )}
              </button>
            </div>
          </div>
          <div className="profile-info-divider" />
          
          <div className="profile-info-row">
            <div className="profile-info-label">Email address</div>
            <div className="profile-info-value profile-info-value-email">{mockUserInfo.email}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileInfo;